import { Component, OnInit } from '@angular/core';

async function deconnecter_fn() {
  var audio = new Audio('../assets/aud/exit.ogg');
  audio.play();
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
        window.location.href = '/connecter' ;

} ;

function aproposdefn() {
  alert("Bonjour !! \n\n Ceci est un mini-projet ISTIC pour le niveau LGLSI-2 en 2021 \n Réalisé par: Mohamed Dhia Jebali - Mariem Benjaballah - Aymen Tayari \n\n C'est une application web faite par angular pour la gestion des employés \n Vous pouvez ajouter, modifier, supprimer, chercher et consulter chaque employé dans la base de données de l'application");
}

function hoversoundfn() {
  var audio = new Audio('../assets/aud/cursor.ogg');
audio.play();
}

function clicksoundfn() {
  var audio = new Audio('../assets/aud/select.ogg');
audio.play();
}

async function backend_tester_fn() {
  var eid = localStorage.getItem("connecteid");
  var motdepasse = localStorage.getItem("connectmdp");
  const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_connecter_bd?eid=${eid}&motdepasse=${motdepasse}`) ;   
  if (rep.ok){
    rep.json().then((data)=>{ 
      if (data.length != 0) {
        if (data[0].admin == 1) {
          (document.getElementById("connectnomm") as HTMLFormElement).insertAdjacentHTML("afterbegin",data[0].nom+" ") ;
        }
        if (data[0].admin == 0) {
          window.location.href = '/accueilemploye' ;
        }
      }
      else {
        localStorage.removeItem("connecteid");
        localStorage.removeItem("connectmdp");
        localStorage.removeItem("connectnom");
        window.location.href = '/connecter' ;
      }
    }) 
  } else {
    localStorage.removeItem("connecteid");
    localStorage.removeItem("connectmdp");
    localStorage.removeItem("connectnom");
    window.location.href = '/connecter' ;
  }
} ;

async function backend_chercher_fn() {

  var eid =  (document.getElementById('eid') as HTMLFormElement).value 
  
    const rep = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_chercher_bd?eid=${eid}`) ;   
  
    if (rep.ok){
      rep.json().then((data)=>{ 
  
        (document.getElementById('cin') as HTMLFormElement).value =  data[0].cin ;
        (document.getElementById('motdepasse') as HTMLFormElement).value =  data[0].mdp ;
        if (data[0].admin == 1) {  (document.getElementById('admincb') as HTMLFormElement).checked = true ;}  
        (document.getElementById('prenom') as HTMLFormElement).value =  data[0].prenom ;
        (document.getElementById('nom') as HTMLFormElement).value =  data[0].nom ;
        (document.getElementById('dn') as HTMLFormElement).value =  data[0].datenaissance ;
        (document.getElementById('ville') as HTMLFormElement).value =  data[0].ville ;
        (document.getElementById('email') as HTMLFormElement).value =  data[0].email ;
        (document.getElementById('tel') as HTMLFormElement).value =  data[0].numtel ;
        (document.getElementById('salaire') as HTMLFormElement).value =  data[0].salaire ;
        (document.getElementById('di') as HTMLFormElement).value =  data[0].dateinscription ;


        var imgg = data[0].photo ;
        (document.getElementById('imgg') as HTMLFormElement).innerHTML =  `         <div class=" text-center col-sm-12 col-md-12 col-lg-12 col-xl-12" id="imgg">
        <img src="`+imgg+`"  width="120" height="120" /> <br><br>
        <h2>Photo</h2>
    </div>` ;
  
        var d1 = data[0].dateinscription ; 
        var d2 = Date.parse(d1) ;
        var d3 = new Date ;
        var d4 = d3.toString() ;
        var d5 = Date.parse(d4) ;
  
        var diffTime = Math.abs(d5 - d2);
        var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
        (document.getElementById('nbj') as HTMLFormElement).value =  diffDays ;

        var audio = new Audio('../assets/aud/loaded.ogg');
        audio.play();
  
      
      })
    }
  
    const rep2 = await fetch(`http://127.0.0.1:8000/gestionemployes/backend_chercher_tache_bd?eid=${eid}`) ;   
  
    if (rep2.ok){
      rep2.json().then((data)=>{ 
  
        (document.getElementById('tlist') as HTMLFormElement).disabled = false ;

        (document.getElementById('tlist') as HTMLFormElement).innerHTML = `<select style="width: 250px; font-size:18px;" name="tlist" id="tlist"> <option value="tilist">appuyez pour l'affichier</option> </select>`

        for(var i=0 ; i<data.length;i++) {
          (document.getElementById('tlist') as HTMLFormElement).insertAdjacentHTML("beforeend",`<option value="tilist"> ${data[i].tachenom} / ${data[i].directeureid}</option> ` ) ;
        }
  
  
      }) 
    }
  
  } ;

@Component({
  selector: 'app-chercher',
  templateUrl: './chercher.component.html',
  styleUrls: ['./chercher.component.css']
})


export class ChercherComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    backend_tester_fn() ;
  }

  aproposderun() {
    aproposdefn();
  }

  backend_chercher() {
    backend_chercher_fn();
  }

  hoversound() {
    hoversoundfn();
  }

  clicksound() {
    clicksoundfn();
  }

  deconnecter() {
    deconnecter_fn() 
  }

}
